import { useToast } from '@/libraries/vue-toast';

export const toast = useToast();

export default {
  toast,
};
